import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingHeart } from "@fortawesome/free-solid-svg-icons";

interface BankInfo {
  name: string;
  number: string;
  owner: string;
}

const bankData: BankInfo[] = [
  {
    name: "행정계좌",
    number: "국민 621537-04-001068",
    owner: "예금주: 처음사랑교회",
  },
  {
    name: "선교계좌",
    number: "농협 351-0934-1623-83",
    owner: "예금주: 처음사랑교회",
  },
];

const OfferingSection = () => {
  return (
    <Section className="offering-section" id="offering">
      <Container className="container">
        <SectionHeader className="section-header">
          <SectionTitle className="section-title">
            <FontAwesomeIcon
              icon={faHandHoldingHeart}
              className="section-icon"
            />{" "}
            온라인 헌금
          </SectionTitle>
          <SectionDesc className="section-desc">
            마음을 담아 드리는 헌금 안내입니다.
          </SectionDesc>
        </SectionHeader>

        <OfferingBox className="offering-box">
          <Quote>
            "각각 그 마음에 정한 대로 할 것이요 인색함으로나 억지로 하지 말지니
            <br />
            하나님은 즐겨 내는 자를 사랑하시느니라" (고후 9:7)
          </Quote>
          <BankInfoGrid className="bank-info-grid">
            {bankData.map((bank, index) => (
              <BankCard key={index} className="bank-card">
                <BankName className="bank-name">{bank.name}</BankName>
                <BankNum className="bank-num">{bank.number}</BankNum>
                <BankOwner className="bank-owner">{bank.owner}</BankOwner>
              </BankCard>
            ))}
          </BankInfoGrid>
          <OfferingNote className="offering-note">
            * 송금 시 '이름+헌금종류'를 기재해 주세요. (예: 홍길동십일조)
          </OfferingNote>
        </OfferingBox>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  background: #f9f9f9;
  padding: 80px 0;
  position: relative;

  @media (max-width: 768px) {
    padding: 60px 0;
  }

  @media (max-width: 480px) {
    padding: 40px 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const SectionTitle = styled.h2`
  font-size: 32px;
  color: #004094;
  margin-bottom: 5px;
  letter-spacing: -1px;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-weight: 700;

  .section-icon {
    font-size: 0.9em;
    color: #004094;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    flex-direction: column;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    gap: 5px;
  }
`;

const SectionDesc = styled.p`
  font-size: 18px;
  color: #555;
  font-weight: 300;
  word-break: keep-all;
`;

const OfferingBox = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border: 1px solid #eee;
  padding: 40px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.03);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }

  @media (max-width: 480px) {
    padding: 25px 15px;
  }
`;

const Quote = styled.p`
  font-weight: 300;
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const BankInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

const BankCard = styled.div`
  background: #f9f9f9;
  padding: 25px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: 0.3s;

  &:hover {
    border-color: #004094;
  }

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 15px;
  }
`;

const BankName = styled.div`
  font-size: 16px;
  color: #004094;
  font-weight: 700;
  margin-bottom: 5px;
`;

const BankNum = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const BankOwner = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 300;
`;

const OfferingNote = styled.div`
  margin-top: 30px;
  font-size: 14px;
  color: black;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export default OfferingSection;
